module.exports = __webpack_public_path__ + "img/20191017164159355.700484af.jpg";